
export const objMap = (obj, fun) => Object.entries(obj).reduce(
  (prev, [key, value]) => ({
    ...prev,
    [key]: fun(key, value),
  }),
  {},
);

export const objFilter = (obj, fun) => Object.entries(obj).reduce(
  (prev, [key, value]) => ({
    ...prev,
    ...(fun(key, value) ? { [key]: value } : {}),
  }),
  {},
);

export const objReduce = (obj, fun, initialValue) => Object.entries(obj).reduce(
  (prev, [key, value]) => fun(prev, key, value),
  initialValue,
);

export const paramsToObject = (searchParams) => {
  const obj = {};

  for (const key of searchParams.keys()) {
    if (searchParams.getAll(key).length > 1) {
      obj[key] = searchParams.getAll(key);
    } else {
      obj[key] = searchParams.get(key);
    }
  }

  return obj;
};

export const normalizeJson = (obj) => JSON.stringify(obj, Object.keys(obj).sort());

export const removeParam = (searchParams, keySearch, valueSearch) => {
  const value = searchParams.getAll(keySearch);

  if (value.length > 1) {
    const newValue = value.filter((el) => el !== valueSearch);
    searchParams.delete(keySearch);
    newValue.forEach((paramValue) => searchParams.append(keySearch, paramValue));
  } else {
    searchParams.delete(keySearch);
  }

  return searchParams;
};

export const typeOf = (value) => (Array.isArray(value) ? 'array' : typeof value);

export const cleanObject = (data) => {
  const typeOfData = typeOf(data);

  if (typeOfData === 'array') return data;

  const newData = { ...data };

  if (newData) {
    Object.keys(newData).forEach((k) => {
      if (newData[k] === '' || newData[k] === 'false' || newData[k] === false || k.endsWith('_aux') || newData[k] === undefined
      || newData[k].length === 0) {
        delete newData[k];
      }
    });
  }

  return newData || {};
};

export const createCustomEvent = (eventName, value) => {
  const event = new CustomEvent(eventName, {});
  Object.defineProperty(event, 'target', { writable: false, value });

  return event;
};

export const isEmptyObject = (value) => (
  value && Object.keys(value).length === 0 && value.constructor === Object
);

export const orderByOrderingAsc = (a, b) => a.ordering - b.ordering;

export const normalizeObjectValues = (object1, object2) => {
  const defaultTypes = objMap(object1, (key, value) => typeOf(value));

  const newValues = objMap(object2, (key, value) => {
    const isDiffType = defaultTypes[key] !== typeOf(value);
    const isArray = defaultTypes[key] === 'array';

    if (!isDiffType) return value;
    if (isArray) return [value];

    return value;
  });

  return newValues;
};

export const compare = (key, priorities, order = 'ASC') => (a, b) => {
  const condition1 = priorities.indexOf(a[key]);
  const condition2 = priorities.indexOf(b[key]);
  const result = condition1 - condition2;

  return order === 'ASC' ? result : -result;
};
